module.exports = __webpack_public_path__ + "media/success.e10fb2df.mp3";